import type { IEventBus, INotificationService, NotificationModel } from "@emanprague/shared-services";
import { SeverityLevel } from "@emanprague/shared-services";
import { uniqueId } from "lodash";
import { action, observable } from "mobx";
import { GeneralEvents } from "./events";

export default class NotificationService implements INotificationService {
  @observable notifications = new Map<string, NotificationModel>();

  constructor(eventBus: IEventBus) {
    this.subscribeToEvents(eventBus);
  }

  @action addNotification(message: string, severity: SeverityLevel = SeverityLevel.information, key?: string, timeout = 5000) {
    const id = key ?? uniqueId();

    const existingHandle = this.notifications.get(id)?.timeoutHandle;
    if (existingHandle) {
      clearTimeout(existingHandle);
    }

    this.notifications.set(id, {
      message,
      severity,
      created: new Date(),
      timeoutHandle: timeout ? setTimeout(this.removeNotification, timeout, id) : undefined,
    });
  }

  @action.bound removeNotification(key: string) {
    this.notifications.delete(key);
  }

  private subscribeToEvents(eventBus: IEventBus) {
    eventBus.subscribe(GeneralEvents.apiError, event => {
      this.addNotification(event.payload.errorMessage, SeverityLevel.critical);
    });
  }
}
